import React from "react";
import PropTypes from "prop-types";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import FormSelect from "Common/Custom/FormSelect";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

const EditCandidateShortlistForm = ({
    fields,
    values,
    errors = {},
    handleChange,
    handleSubmit,
    loading = false,
    title = "Edit Candidate Shortlist",
    CandidateOptions = [],
    PositionOptions = [],
}) => {
    const optionConfig = {
        candidate_id: {
            list: CandidateOptions,
            valueKey: "candidate_id",
            labelKey: "candidate_name",
        },
        position_id: {
            list: PositionOptions,
            valueKey: "position_id",
            labelKey: "position_name",
        },
    };

    const renderField = (field) => {
        if (field.type === "select") {
            return (
                <FormSelect
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    options={getSelectOptions(field.name, optionConfig)}
                    error={errors[field.name]}
                />
            );
        }

        if (field.type === "date" || field.type === "datetime") {
            return (
                <FormDatePicker
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                    enableTime={field.type === "datetime"}
                    mode={field.type === "datetime" ? "datetime" : "date"}
                    dateFormat={field.type === "datetime" ? "d-m-Y H:i" : "d-m-Y"}
                />
            );
        }

        return null;
    };

    return (
        <PageBody
            onSubmit={handleSubmit}
            headerchildren={<HeadingOne>{title}</HeadingOne>}
        >
            {fields.map((field) => renderField(field))}

            <FormSubmitButton
                label="Update"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

EditCandidateShortlistForm.propTypes = {
    fields: PropTypes.array.isRequired,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    title: PropTypes.string,
    CandidateOptions: PropTypes.array,
    PositionOptions: PropTypes.array,
};

export default EditCandidateShortlistForm;
